<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      stateType: 0, // 0添加 1编辑
      rowObj: {},
      detailObj:{}, // 详情第二张表
    };
  },
  components: {
    Page: () => import("./components/page.vue"),
    AddTask: () => import("./components/addTask.vue"),
    studyRecord: () => import("./components/studyRecord.vue"),
    statistics: () => import("./components/statistics.vue"),
    detailPage: () => import("./components/detailPage.vue"),
    // ModifyThe: () => import("../../layout/components/userCenter/index.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Page";
        case 1:
          return "AddTask";
        case 2:
          return "studyRecord";
        case 3:
          return "statistics";
        case 4:
          return "detailPage";
        // case 5:
        //   return "ModifyThe";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>